export const displayTextWithOverflow = (
    text: string | undefined,
    tooltip: string | undefined = text,
    maxLength: number = 25
) => {
    if (!text) return "";
    return text.length > maxLength ? (
        <span title={tooltip} aria-label={text}>
            {text.substring(0, maxLength)}...
        </span>
    ) : (
        <span title={tooltip}>{text}</span>
    );
};
